import React, { type FC } from 'react';
import ScrollableAnchor from 'react-scrollable-anchor';
import Container from '../../container';
import Title from '../../title';
import { Grid } from '../../UIKit/system';
import { VideoLongCard } from '../../video-long-card';

interface VideosSectionProps {
  videos: {
    id: string;
    name: string;
    categories: string;
    duration: number;
    source?: string;
    image: { [key: string]: any };
  }[];
}

export const VideosSection: FC<VideosSectionProps> = (props) => {
  const { videos } = props;

  return (
    <ScrollableAnchor id="videos">
      <Container large py={[48, 96]}>
        <Grid
          gridAutoFlow={['row', 'row', 'column']}
          gridGap={[30, 30, 99]}
          gridTemplateColumns={['auto', 'auto', 'auto 1fr']}
        >
          <Grid width={['auto', 180]} alignContent="start">
            <Title as="h2" fontSizeSmall>
              Videos!
            </Title>
          </Grid>
          <Grid gridAutoFlow="row" gridGap={24}>
            {videos.map((video) => {
              if (!video.source) return null;

              return (
                <VideoLongCard
                  key={video.id}
                  image={video.image}
                  subtitle={video.categories}
                  title={video.name}
                  duration={video.duration}
                  video={video.source}
                />
              );
            })}
          </Grid>
        </Grid>
      </Container>
    </ScrollableAnchor>
  );
};
